import React from "react";

const EntryColor = ({ entryNum, saddleNum, finishPos, style }) => {
  let entryNumColor;
  if (finishPos === -1) {
    entryNumColor = { backgroundColor: "#d9d9d9", color: "#000", textDecoration: 'line-through'};
  } else {
    switch (entryNum) {
      case 1:
        entryNumColor = { backgroundColor: "red", color: "#ffffff" };
        break;
      case 2:
        entryNumColor = { backgroundColor: "lightblue", color: "#000000" };
        break;
      case 3:
        entryNumColor = { backgroundColor: "blue", color: "#ffffff" };
        break;
      case 4:
        entryNumColor = { backgroundColor: "orange", color: "#000000" };
        break;
      case 5:
        entryNumColor = { backgroundColor: "#156312", color: "#ffffff" };
        break;
      case 6:
        entryNumColor = { backgroundColor: "gray", color: "#ffffff" };
        break;
      case 7:
        entryNumColor = { backgroundColor: "#F87603", color: "#ffffff" };
        break;
      case 8:
        entryNumColor = { backgroundColor: "#FF84C5", color: "#ffffff" };
        break;
      case 9:
        entryNumColor = { backgroundColor: "lightBlue", color: "#000000" };
        break;
      case 10:
        entryNumColor = { backgroundColor: "#8254FB", color: "#ffffff" };
        break;
      case 11:
        entryNumColor = { backgroundColor: "#858585", color: "#ffffff" };
        break;
      case 12:
        entryNumColor = { backgroundColor: "#279214", color: "#ffffff" };
        break;
      case 13:
        entryNumColor = { backgroundColor: "#472706", color: "#ffffff" };
        break;
      case 14:
        entryNumColor = { backgroundColor: "#731B49", color: "#ffffff" };
        break;
      case 15:
        entryNumColor = { backgroundColor: "#8B5B29", color: "#ffffff" };
        break;
      case 16:
        entryNumColor = { backgroundColor: "#6786B0", color: "#000000" };
        break;
      case 17:
        entryNumColor = { backgroundColor: "#102EA0", color: "#000000" };
        break;
      case 18:
        entryNumColor = { backgroundColor: "#0F5A0A", color: "#ffffff" };
        break;
      case 19:
        entryNumColor = { backgroundColor: "#11487E", color: "#ffffff" };
        break;
      default:
        entryNumColor = { backgroundColor: "gray", color: "#000000" };
        break;
    }
  }

  return (
    <h4 key={saddleNum} style={style}>
      <span className="badge rounded-circle" style={entryNumColor}>
        {saddleNum}
      </span>
    </h4>
  );
};

export default EntryColor;
